<template>
  <div class="legend">
      <div
        v-for="(color, i) in legend.colorCode"
        :key="i"
        class="legend__color"
      >
        <div :style="{ backgroundColor: color.color }"></div>
        <p>{{ color.text }}</p>
      </div>
      <h5>{{ legend.title || "" }}</h5>
    </div>
</template>

<script>
export default {
  props: {
    legend: Object
  }
}
</script>

<style scoped>
  .legend {
  position: absolute;
  padding: 15px;
  bottom: 0;
  left: 0;
  z-index: 999;
  border-radius: 0 5px;
  background-color: rgba(255, 255, 255, 0.8);
}

.legend__color {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.legend__color p {
  margin: 0;
  font-size: 12px;
}
.legend__color div {
  width: 30px;
  height: 15px;
  margin-right: 10px;
}

</style>